<template>
  <!-- Header : 로그인 전 : 로그인 후는 주석 풀어주면 됨 -->
  <header>
    <nav>
      <h1 class="logo-top" @click="fnMain"></h1>
      <ul class="header-menu1" v-if="isShowMenu">
        <li><a href="javascript:false" @click="fnMain">고객관리</a></li>
        <!--        <li>
          <a href="javascript:false" @click="fnCarInsurance">자동차보험조회</a>
        </li>-->
      </ul>

      <ul class="header-menu2">
        <li v-if="isShowMenu">
          <router-link to="/expert/register" tag="a">전문가등록</router-link>
        </li>
        <li>
          <a href="javascript:false" v-if="isShowMenu" @click="fnService">고객센터</a>
        </li>
        <li v-if="isShowMenu">
          <button class="btn-header" @click="fnManual">사용 메뉴얼</button>
        </li>
        <li v-if="isShowMenu">
          <button class="menu-mypage" @click="fnMyPage"></button>
        </li>
      </ul>
    </nav>
  </header>
  <!--// Header -->
</template>

<script>
import { computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default {
  name: 'header-bar-index',
  emits: ['refresh'],
  setup() {
    /** init */
    const store = useStore();
    const router = useRouter();
    const { proxy } = getCurrentInstance();

    const expertData = computed(() => {
      return store.getters['expert/getData'];
    });

    const isShowMenu = computed(() => {
      // return true;
      // return !proxy.$Util.isEmpty(expertData.value) && expertData.value.isTicket === 1;
      return !proxy.$Util.isEmpty(expertData.value);
    });

    const fnManual = () => {
      alert('준비중입니다.');
      // window.open(proxy.$ConstCode.CODE_ENV_LIST.USE_MANUAL_URL, '_blank');
    };

    const fnMain = () => {
      proxy.$emit('refresh');
      router.push({
        path: '/'
      });
    };
    const fnMyPage = () => {
      router.push({
        path: '/my-page'
      });
    };

    const fnService = () => {
      router.push({
        path: '/service'
      });
    };

    const fnCarInsurance = () => {
      window.open('https://e-insmarket.or.kr/aimt/aimtRealIntro.knia');
    };

    return {
      fnService,
      fnMyPage,
      fnMain,
      fnManual,
      fnCarInsurance,
      isShowMenu,
      expertData
    };
  }
};
</script>

<style scoped>
.logo-top:hover {
  cursor: pointer;
}
</style>
